<template>
  <div class="flex flex-col gap-4">
    <p class="mt-5 text-[1.3rem] font-medium text-black">
      {{ $t('Select a payment method') }}
    </p>
    <div v-if="methods.length" class="grid gap-3">
      <button
        v-for="method in methods"
        :key="method.id"
        type="button"
        class="w-full rounded-[2.4rem] border px-4 py-3 text-left transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black"
        :class="selectedId === method.id
          ? 'border-black bg-black/[0.04] shadow-sm'
          : 'border-black/10 bg-white hover:border-black/40'"
        @click="$emit('select', method.id)"
      >
        <div class="flex items-center gap-4">
          <div class="flex h-12 w-12 items-center justify-center rounded-[2.4rem] bg-black/5 text-black">
            <svg
              class="h-6 w-6"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path :d="resolveIconPath(method)" />
            </svg>
          </div>
          <div class="flex-1">
            <p class="text-[1.4rem] font-semibold text-black">
              {{ method.name || $t('Payment method') }}
            </p>
            <p v-if="method.description" class="text-[1.2rem] text-[color:var(--gray)]">
              {{ method.description }}
            </p>
          </div>
          <span
            v-if="selectedId === method.id"
            class="text-[1.1rem] font-semibold uppercase tracking-wide text-black"
          >
            {{ $t('Selected') }}
          </span>
        </div>
      </button>
    </div>
    <p v-else class="text-[1.3rem] text-red-600">
      {{ $t('No payment methods are available at this time.') }}
    </p>
    <div
      v-if="allowTokenization || forceSave"
      class="flex gap-3 rounded-[2.4rem] border border-black/10 bg-black/[0.02] px-4 py-3"
    >
      <input
        id="save-card"
        type="checkbox"
        class="mt-1 h-5 w-5 rounded border-black/20 text-black focus:ring-black"
        :checked="forceSave || saveCard"
        :disabled="forceSave"
        @change="$emit('update:saveCard', $event.target.checked)"
      />
      <label for="save-card" class="flex-1 space-y-1 text-[1.2rem] leading-snug text-black">
        <span class="block font-semibold">
          {{ $t('Save card for future purchases?') }}
        </span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CheckoutPaymentMethods',
  props: {
    methods: {
      type: Array,
      default: () => [],
    },
    selectedId: {
      type: [String, Number],
      default: null,
    },
    allowTokenization: {
      type: Boolean,
      default: false,
    },
    forceSave: {
      type: Boolean,
      default: false,
    },
    saveCard: {
      type: Boolean,
      default: false,
    },
    getIconPath: {
      type: Function,
      default: null,
    },
  },
  emits: ['select', 'update:saveCard'],
  methods: {
    resolveIconPath(method) {
      if (typeof this.getIconPath === 'function') {
        return this.getIconPath(method);
      }
      return 'M3 7h18a1 1 0 011 1v8a2 2 0 01-2 2H4a2 2 0 01-2-2V8a1 1 0 011-1zm0 4h20';
    },
  },
};
</script>
